import React, { createContext, useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { decodeToken } from 'react-jwt';

import { getUser, logout } from '../services/auth';
import useDataApi from '../hooks/useDataApi';
import { fnDecodeStorageToken } from '../utils/encodeLocalStorage';
import { C_SELECTED_PANELS_STORAGE_KEY } from "./Paineis"

export const AuthContext = createContext({
  oUser: { data: null },
  fnLogout: async () => { },
  fnReloadUser: async () => { },
});

export function fnCleanStorage() {
  localStorage.removeItem("cAccessToken")
  localStorage.removeItem("cStorageToken")

  sessionStorage.removeItem("nCustId")
  sessionStorage.removeItem("cOldCompanyName")
  sessionStorage.removeItem(C_SELECTED_PANELS_STORAGE_KEY)
}

export function AuthContextProvider({ children }) {
  const [userRes, fetchUser] = useDataApi(getUser);
  const [oUser, setOUser] = useState({ data: null });
  const { blockId } = useParams();

  async function fnReloadUser() {
    const nUserId = fnDecodeStorageToken()?.nUserId;
    if (blockId && !nUserId && !localStorage.getItem('qrCodeUrl')) {
      localStorage.setItem('qrCodeUrl', window.location.pathname);
    }
    if (userRes.loading || !nUserId) return;
    const response = await fetchUser(nUserId);
    const decoded = decodeToken(response);

    const oStorageToken = fnDecodeStorageToken()

    const bIsTrial = oStorageToken?.bTrial || false
    const operationalPanelNVersion = oStorageToken?.aModulesVersion?.["operational-panel"]?.version || 1

    const bHasIndicatorModule = operationalPanelNVersion >= 3 || bIsTrial === true
    const bHasRiskAndNonConformitesModule = operationalPanelNVersion >= 4 || bIsTrial === true
    const nDocumentsVersion = bIsTrial === true
      ? 2
      : oStorageToken?.aModulesVersion?.["documents"]?.version || 1
    const bIsDocumentsV2 = nDocumentsVersion >= 2

    const oDataUser = {
      ...decoded.oUser,
      bHasIndicatorModule,
      bHasRiskAndNonConformitesModule,
      nDocumentsVersion,
      bIsDocumentsV2,
    }
    setOUser({ data: oDataUser });
  }

  async function fnLogout() {
    await logout();
    fnCleanStorage();
    window.location.href = '/';

  }

  const validateSession = useCallback((e) => {
    if (e.storageArea !== localStorage || e.key !== "cStorageToken") return;

    const oTokenOld = e.oldValue ? decodeToken(e.oldValue) : {};
    if (!oTokenOld.nCustId) return;

    const oTokenNew = e.newValue && decodeToken(e.newValue);
    if (!oTokenNew || oTokenOld.nCustId !== oTokenNew.nCustId) {
      window.location.href = '/';
    }
  }, []);

  useEffect(() => {
    fnReloadUser();

    window.addEventListener('storage', validateSession);

    return () => {
      window.removeEventListener('storage', validateSession);
    };
  }, []);

  const value = useMemo(() => ({
    oUser,
    fnLogout,
    fnReloadUser,
  }), [oUser]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
